/// <amd-module name="Agile/Sprints/Directory/SprintDirectoryConstants" />
export const AreaName = "Sprints";
export const LOAD_DIRECTORY = "SprintsRegistration_LoadSprintDirectory";
